export default __webpack_public_path__ + "static/media/elec-8.3a9d943b.png";